import React, {
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react';
import { authProvider } from "../authProvider";
import { getAccess, getMembersById } from "../services/formCombos.service.js";

export const AuthContext = createContext(
  {},
);

export const AuthContextProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState();
  const [userAccess, setUserAccess] = useState();
  
  useEffect(() => {
    getMembersById(localStorage.getItem('i18nextLng'), authProvider.account.accountIdentifier).then(res => {
      setUserInfo(res.data);

      getAccess().then((response) => {
        const access = {};
        
        const adminFunctionalityNames = [
          'listBusinessUnits',
          'createGroup',
          'updateCommitteePackage',
          'listCommitteePackage',
          'updateGroup',
          'listGroup',
          'deleteGroup',
          'setActiveGroup',
          'createCommitteePackage',
          'setActiveCommitteePackage',
          'createPackages',
        ];
        let systemManagement = response.data.master;
        
        response?.data?.functionalityNames?.forEach((funcionality) => {
          if (adminFunctionalityNames.includes(funcionality)) {
            systemManagement = true;
          }

          access[funcionality] = true;
        });

        setUserAccess({ ...access, systemManagement });
        setUserInfo({ ...res.data, master: response.data.master });
      });
    });
  }, [authProvider]);

  return (
    <AuthContext.Provider
      value={{ userInfo, userAccess }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export function useAuth() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider.');
  }

  return context;
}
